/**
 * Created by nguyendx 2017/12/01.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiCoreiCheckService } from './ApiCoreiCheck.service';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class AuthBusinessService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    loginBusiness(body){
        return this.post('/redirect-login', body);
    }

    checkBuyOnSeller(shop_id, barcode) {
        return this.get(`/check-buy-on-seller/${shop_id}/${barcode}`);
    }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/AuthBusiness.service.ts